import React from "react";
import { css } from "glamor";
import { spacing } from "../../library/theme";

const wrapperClass = css({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.25fr)",
  gap: spacing.l,
  alignItems: "flex-start",
  "@media (max-width: 900px)": {
    gridTemplateColumns: "1fr",
  },
});

const leftColumnClass = css({
  minWidth: 0,
});

const rightColumnClass = css({
  minWidth: 0,
});

export default function InteractiveLayout({ leftColumn, rightColumn }) {
  return (
    <div className={wrapperClass} data-testid="interactive-layout">
      <div className={leftColumnClass} data-testid="interactive-layout-left">
        {leftColumn}
      </div>
      <div className={rightColumnClass} data-testid="interactive-layout-right">
        {rightColumn}
      </div>
    </div>
  );
}
